import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from 'src/app/shared/shared.module';
import { AiConnectorDialogComponent } from './ai-connector/ai-connector-dialog/ai-connector-dialog.component';
import { AiConnectorComponent } from './ai-connector/ai-connector.component';
import { ApiConnectorModule } from './api-connector/api-connector.module';
import { NoteModule } from './note/note.module';
import { RecurringNotifDialogComponent } from './recurring-notif/recurring-notif-dialog/recurring-notif-dialog.component';
import { RecurringNotifComponent } from './recurring-notif/recurring-notif.component';

@NgModule({
  declarations: [
    AiConnectorComponent,
    AiConnectorDialogComponent,
    RecurringNotifComponent,
    RecurringNotifDialogComponent,
  ],
  imports: [CommonModule, SharedModule, ApiConnectorModule, NoteModule],
})
export class QuickRepliesCommonsModule {}
